/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ButtonToken, ButtonTokenInterface } from "../ButtonToken";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oracle",
        type: "address",
      },
    ],
    name: "OracleUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "epoch",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newScalar",
        type: "uint256",
      },
    ],
    name: "Rebase",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "MAX_PRICE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_UNDERLYING",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PRICE_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner_",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "balanceOfUnderlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "burnAll",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "burnAllTo",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burnTo",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedAmount",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "uAmount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "uAmount",
        type: "uint256",
      },
    ],
    name: "depositFor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedAmount",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "underlying_",
        type: "address",
      },
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
      {
        internalType: "address",
        name: "oracle_",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lastPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mintFor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "oracle",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rebase",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "scaledBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "scaledTotalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalUnderlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "transferAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "transferAllFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "underlying",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "uAmount",
        type: "uint256",
      },
    ],
    name: "underlyingToWrapper",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "oracle_",
        type: "address",
      },
    ],
    name: "updateOracle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "uAmount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawAll",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "withdrawAllTo",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "uAmount",
        type: "uint256",
      },
    ],
    name: "withdrawTo",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "wrapperToUnderlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ButtonTokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ButtonTokenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ButtonToken__factory extends ContractFactory {
  constructor(...args: ButtonTokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ButtonToken> {
    return super.deploy(overrides || {}) as Promise<ButtonToken>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ButtonToken {
    return super.attach(address) as ButtonToken;
  }
  connect(signer: Signer): ButtonToken__factory {
    return super.connect(signer) as ButtonToken__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ButtonTokenInterface {
    return new utils.Interface(_abi) as ButtonTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ButtonToken {
    return new Contract(address, _abi, signerOrProvider) as ButtonToken;
  }
}
